import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceForm from '../components/InvoiceForm';
import { useGetInvoiceHandler } from '../dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function InvoiceDetailsPage({ isPurchase }) {
  const navigate = useNavigate();
  useDocumentTitle('Invoice Details');
  const { document_id } = useParams();
  const { invoice, isLoading } = useGetInvoiceHandler(document_id, isPurchase);
  const onClickingBackButton = async () => {
    return navigate(isPurchase ? '/purchases/documents?tab=invoices' : '/sales/documents?tab=invoices');
  };

  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <InvoiceForm
        onSubmit={() => {}}
        onCancel={onClickingBackButton}
        initialData={invoice}
        readOnly={true}
        isPurchase={isPurchase}
      />
    </Stack>
  );
}
